import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './Home/Home';
import AllProjects from './AllProjects/allProjects';
import Gallary from './Gallary/Gallary';
import './App.css';
import './MediaQuery.css';

function App() {
  const [openGallary, setOpenGallary] = useState(false)
  const [gallaryMedia, setGallaryMedia] = useState([])

  const getMediaList = (list) => {
    setGallaryMedia(list)
    updateModalStatus(true)
  }

  const updateModalStatus = (bool) => {
    setOpenGallary(bool)
    if(bool) {
      document.body.style.overflow = 'hidden'
    }else {
      setGallaryMedia([])
      document.body.style.overflow = 'scroll'
    }
  }

  let gallaryModal = openGallary? <Gallary items={gallaryMedia} updateModalStatus={updateModalStatus}/>: null

  return (
    <div className="App">
      {gallaryModal}
      <Router>
        <Switch>
          <Route 
            path="/" 
            exact 
            render={(props) => <Home {...props} getMediaList={getMediaList} />}
          />
          <Route path="/archive" component={AllProjects} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
